import { render, staticRenderFns } from "./DeviceMake.vue?vue&type=template&id=795bd324&scoped=true&"
import script from "./DeviceMake.vue?vue&type=script&lang=js&"
export * from "./DeviceMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bd324",
  null
  
)

export default component.exports